import { render, staticRenderFns } from "./SignatureConfig.vue?vue&type=template&id=55c5dc80&scoped=true&"
import script from "./SignatureConfig.vue?vue&type=script&lang=js&"
export * from "./SignatureConfig.vue?vue&type=script&lang=js&"
import style0 from "./SignatureConfig.vue?vue&type=style&index=0&id=55c5dc80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5dc80",
  null
  
)

export default component.exports